import axiosClient from '../api/axiosClient';
import API from '../Constants/apiRoutes';

const cioService = {
  /** GET /admin/cio/dashboard -> summary cards. */
  getDashboard: async () => {
    const { data } = await axiosClient.get(API.cioDashboard);
    return data;
  },

  /** GET /admin/cio/onboarding-invitations?status= (status optional, numeric). */
  getInvitations: async (status) => {
    const params = {};
    if (status !== undefined && status !== null && status !== '') params.status = status;
    const { data } = await axiosClient.get(API.invitations.base, { params });
    return data;
  },

  /** POST /admin/cio/onboarding-invitations -> { organizationName, contactEmail, expiresInDays }. */
  createInvitation: async (payload) => {
    const { data } = await axiosClient.post(API.invitations.base, payload);
    return data;
  },

  /** GET /admin/cio/clients?search=&status=&page=&pageSize= -> { items, page, pageSize, totalCount }. */
  getClients: async ({ search, status, page = 1, pageSize = 20 } = {}) => {
    const params = { page, pageSize };
    if (search) params.search = search;
    if (status !== undefined && status !== null && status !== '') params.status = status;
    const { data } = await axiosClient.get(API.clients.list, { params });
    return data;
  },

  /** GET /admin/cio/clients/{id} -> full customer detail (source for every panel). */
  getClient: async (id) => {
    const { data } = await axiosClient.get(API.clients.detail(id));
    return data;
  },

  /** PUT /admin/cio/clients/{id}/commercial-terms. */
  setCommercialTerms: async (id, payload) => {
    const { data } = await axiosClient.put(API.clients.commercialTerms(id), payload);
    return data;
  },

  /** PUT /admin/cio/clients/{id}/deployment. */
  setDeployment: async (id, payload) => {
    const { data } = await axiosClient.put(API.clients.deployment(id), payload);
    return data;
  },

  /** PATCH /admin/cio/clients/{id}/status -> { status } (numeric ClientStatus). */
  setStatus: async (id, status) => {
    const { data } = await axiosClient.patch(API.clients.status(id), { status });
    return data;
  },

  /** POST /admin/cio/clients/{id}/integration-key/rotate -> one-time key (show once). */
  rotateIntegrationKey: async (id) => {
    const { data } = await axiosClient.post(API.clients.rotateIntegrationKey(id));
    return data;
  },

  /** GET /admin/clients/{clientId}/support-access -> audit records (open = completedAtUtc null). */
  getSupportAccess: async (clientId) => {
    const { data } = await axiosClient.get(API.supportAccess.base(clientId));
    return data;
  },

  /** POST /admin/clients/{clientId}/support-access -> { accessType, purpose }. 409 = prerequisite incomplete. */
  startSupportAccess: async (clientId, payload) => {
    const { data } = await axiosClient.post(API.supportAccess.base(clientId), payload);
    return data;
  },

  /** POST /admin/clients/{clientId}/support-access/{auditId}/complete -> { outcome }. */
  completeSupportAccess: async (clientId, auditId, payload) => {
    const { data } = await axiosClient.post(API.supportAccess.complete(clientId, auditId), payload);
    return data;
  },
};

export default cioService;
